import React from "react";

const EthereumERCIcon = ({ className }) => (
  <svg
    className={className}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1364_7148)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.9375 0C19.102 0 22.1954 0.938384 24.8266 2.69649C27.4578 4.45459 29.5086 6.95345 30.7196 9.87707C31.9306 12.8007 32.2474 16.0177 31.6301 19.1214C31.0127 22.2251 29.4888 25.0761 27.2512 27.3137C25.0136 29.5514 22.1626 31.0752 19.0589 31.6926C15.9552 32.3099 12.7382 31.9931 9.81457 30.7821C6.89095 29.5711 4.39209 27.5203 2.63399 24.8891C0.875884 22.2579 -0.0625 19.1645 -0.0625 16C-0.0625 11.7565 1.62321 7.68687 4.62379 4.68629C7.62437 1.68571 11.694 0 15.9375 0V0Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.9375 3.43555L20.1469 9.725L24.3564 16.0159L15.9375 20.2574L7.51855 15.9999L11.728 9.709L15.9375 3.43555ZM15.9375 21.9519L7.98546 17.709L15.9375 28.5643L23.8895 17.709L15.9375 21.9519Z"
        fill="#343434"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.9375 3.43555L20.147 9.709L24.3564 15.9999L15.9375 12.8217V3.43555Z"
        fill="#343434"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.9375 21.9519L23.9055 17.709L15.9375 28.5803V21.9519Z"
        fill="#313131"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.9375 12.8223L24.3564 16.0004L15.9375 20.2419V12.8223Z"
        fill="#151515"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.9375 3.43555L11.728 9.709L7.51855 15.9999L15.9375 12.8217V3.43555Z"
        fill="#8C8C8C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.9374 21.9519L7.98535 17.709L15.9374 28.5803V21.9519Z"
        fill="#8A8A8A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.9375 12.8223L7.51855 16.0004L15.9375 20.2419V12.8223Z"
        fill="#353535"
      />
    </g>
    <defs>
      <clipPath id="clip0_1364_7148">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default EthereumERCIcon;
